/**
 * Shared validator regex patterns used across the codebase.
 *
 * Lifting these out of individual page/handler files keeps validation
 * consistent (RegisterPage and any future signup / profile flow share
 * one definition) and makes future tightening a single edit (SOP 15
 * Ch.20 audit, LOW — DIP).
 */

/**
 * Pragmatic client-side email check. Matches "any-non-ws-or-@ chars,
 * one @, any-non-ws-or-@ chars, one dot, any-non-ws-or-@ chars". The
 * authoritative check is server-side; this is just for UX gating on
 * the form (no false negatives on the typical user's typed input).
 */
export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

/** True when `value` (whitespace-trimmed) looks like an email. */
export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim())
}

/** Indian mobile number — exactly 10 digits (no country code / spaces). */
export const MOBILE_PATTERN = /^\d{10}$/

/** True when `value` (whitespace-trimmed) is a 10-digit mobile number. */
export function isValidMobile(value: string): boolean {
  return MOBILE_PATTERN.test(value.trim())
}

/** Indian postal PIN code — exactly 6 digits. */
export const PIN_PATTERN = /^\d{6}$/

/** True when `value` (whitespace-trimmed) is a 6-digit PIN code. */
export function isValidPin(value: string): boolean {
  return PIN_PATTERN.test(value.trim())
}
